import type { PropsWithChildren, FC, ReactNode } from 'react';

import { Text } from '../Text/Text';

interface Props {
  id?: string;
  children: ReactNode;
}

/** Internal use only (InputText, InputTelephone, etc.) */
export const Hint: FC<PropsWithChildren<Props>> = ({ id, children }) => (
  <Text id={id} size="BodyS" color="textPrimary">
    {children}
  </Text>
);
